import * as React from 'react'

const OmieIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: 'new 0 0 120 120'
    }}
    viewBox="0 0 120 120"
    width={15}
    height={15}
    {...props}
  >
    <path
      d="M5.7 59.9c0 31.6 24.3 52.8 54.6 52.8 30.4 0 54.6-21.1 54.6-52.8 0-15.3-5.5-29-13.9-37.6C75.6-3.6 53.3 11 47.8 24c-1.1 2.6-.5 4.8 2.8 6.5l44.5 27.8c2 1.1 2 3.9 0 5l-54 26.5c-1.9 1-4.1-.4-4.1-2.5V41c0-17.4 2-23.7 3.5-27.9 1.1-3.2-.5-4.2-2.8-3.1-4 2-32 20.5-32 49.9z"
      style={{
        fill: '#00e2f4'
      }}
    />
  </svg>
)
export default OmieIcon
